import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { removeAllAccountsAction } from "../../../../data/redux/action/add_customer/addAccountsAction";
import { dateConvert } from "../../../../utility/dateModifier";
import CustomModal from "../../../components/customModal/CustomModal";
import UpdateUpiAfterCustomerAdded from "./update_upi";

const RowContainer = ({ value, title }) => {
  const pStyle = {
    color: "black",
    fontSize: 14,
    fontFamily: "Roboto",
    fontWeight: "bold",
  };
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        minWidth: 330,
        justifyContent: "space-between",
        margin: "0px 20px",
        width: "30%",
      }}
    >
      <p
        style={{
          ...pStyle,
          textTransform: "capitalize",
          width: "40%",
        }}
      >
        {title}
      </p>
      <p
        style={{
          ...pStyle,
          color: "#494949",
          fontWeight: "400",
          // textTransform: "capitalize",
          fontSize: 15,
          width: "60%",
          wordBreak: "break-all",
        }}
      >
        {value}
      </p>
    </div>
  );
};
function BasicDetails({ details }) {
  const [upiChecked, setUpiChecked] = useState(false);
  //   const [customerDetails, setCustomerDetails] = useState([]);
  const [userUpiDetails, setUserUpiDetails] = useState([]);
  const navigate = useNavigate();
  const [showUpdateUpiModal, setShowUpdateUpiModal] = useState(false);
  const pStyle = {
    color: "black",
    fontSize: 14,
    fontFamily: "Roboto",
    fontWeight: "bold",
  };
  const dispatch = useDispatch();
  useEffect(() => {
    // setCustomerDetails([customerDetails]);
  }, [details]);

  return (
    <div
      style={{
        width: "100%",
        padding: "0px 20px",
        marginBottom: 20,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          backgroundColor: "#F3F8FF",
          padding: "10px 15px",
          boxSizing: "border-box",
          height: 50,
          display: "flex",
          alignItems: "center",
        }}
      >
        <p
          style={{
            ...pStyle,
            width: "20%",
            minWidth: 100,
          }}
        >
          Service Enabled:
        </p>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              ...pStyle,
              fontWeight: "500",
              width: "100%",
            }}
          >
            Bank Transfers(NEFT,RTGS,IMPS){" "}
            <span style={{ ...pStyle, fontWeight: "500", color: "green" }}>
              (Activated)
            </span>
          </p>
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            {/* <input
              type="checkbox"
              style={{
                height: 17,
                width: 17,
              }}
              onChange={() => {
                // setUpiChecked(!upiChecked);
                setShowUpdateUpiModal(true);
              }}
              value={upiChecked}
            /> */}

            {details?.paymentDetails?.length === 1 && (
              <div
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: 3,
                  border: "1px solid grey",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setShowUpdateUpiModal(true);
                }}
              ></div>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: 20,
              }}
            >
              <p
                style={{
                  ...pStyle,
                  fontWeight: "500",
                }}
              >
                UPI
              </p>
              <span
                style={{
                  ...pStyle,
                  fontWeight: "500",
                  color:
                    details?.paymentDetails?.length === 2 ? "green" : "#0051ED",
                  marginLeft: 20,
                }}
              >
                {details?.paymentDetails?.length === 2
                  ? "(Activated)"
                  : "(Activate)"}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            marginTop: 20,
          }}
        >
          <RowContainer
            title="Name:"
            value={details?.firstName + " " + details?.lastName}
          />
          {/* <RowContainer title="Transfer Type:" value="manohar" /> */}
          <RowContainer title="Mobile Number:" value={details?.mobileNumber} />
          {details?.paymentDetails?.length === 2 && (
            <RowContainer
              title="Merchant Name:"
              value={details?.paymentDetails[1]?.upiDetails?.merchantName}
            />
          )}
          {/* <RowContainer title="Email ID:" value="manohar" /> */}
          {details?.paymentDetails?.length === 2 && (
            <RowContainer
              title="MCC:"
              value={details?.paymentDetails[1]?.upiDetails?.mcc}
            />
          )}
          <RowContainer
            title="VPA:"
            value={details?.paymentDetails[1]?.paymentId}
          />
          {/* <RowContainer title="IFSC:" value="manohar" /> */}
          {details?.paymentDetails?.length === 2 && (
            <RowContainer
              title="Legal Name:"
              value={details?.paymentDetails[1]?.upiDetails?.legalName}
            />
          )}
          <RowContainer
            title="Account Close Date:"
            value={
              details?.closeByDate ? dateConvert(details?.closeByDate) : "N/A"
            }
          />
          {details?.paymentDetails?.length === 2 && (
            <RowContainer
              title="Franchise:"
              value={details?.paymentDetails[1]?.upiDetails?.franchise}
            />
          )}
          {details?.paymentDetails?.length === 2 && (
            <RowContainer
              title="Brand Name"
              value={details?.paymentDetails[1]?.upiDetails?.brandName}
            />
          )}
          {details?.paymentDetails?.length === 2 && (
            <RowContainer
              title="Merchant Type"
              value={details?.paymentDetails[1]?.upiDetails?.merchantType}
            />
          )}
          {details?.paymentDetails?.length === 2 && (
            <RowContainer
              title="Genre"
              value={details?.paymentDetails[1]?.upiDetails?.genre}
            />
          )}
          {details?.paymentDetails?.length === 2 && (
            <RowContainer
              title="Ownership Type"
              value={details?.paymentDetails[1]?.upiDetails?.ownerShipType}
            />
          )}
          {details?.paymentDetails?.length === 2 && (
            <RowContainer
              title="Onboarding Type"
              value={details?.paymentDetails[1]?.upiDetails?.onboardingType}
            />
          )}
        </div>
      </div>

      {showUpdateUpiModal && (
        <CustomModal
          open={showUpdateUpiModal}
          onClose={() => {
            setShowUpdateUpiModal(false);
            dispatch(removeAllAccountsAction([]));
          }}
        >
          <UpdateUpiAfterCustomerAdded
            customerDetails={details}
            onClose={() => {
              setShowUpdateUpiModal(false);
              dispatch(removeAllAccountsAction([]));
            }}
            onSuccess={() => {
              navigate("/customers");
            }}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default BasicDetails;
